import axios from "axios";

const requestToken = ({ user, type }) => {
  const form = new FormData();
  form.append("userId", user.userId);
  form.append("password", user.password);
  form.append("type", type);
  form.append("grant_type", "password");
  const requestData = {
    url: `${process.env.VUE_APP_APIURL}/oauth/token`,
    method: "POST",
    auth: {
      username: process.env.VUE_APP_CLIENTID,
      password: process.env.VUE_APP_CLIENTSECRET
    },
    data: form
  };
  return axios(requestData);
};

export { requestToken };
